export default class QueryString {
    constructor(str) {
        this.str = str;
    }
    toObject() {
        return this.str.split('&').reduce((prev, cur) => {
            const divided = cur.split('=');
            prev[divided[0]] = decodeURIComponent(divided[1]);
            return prev;
        }, {});
    }
}
